import React, { useEffect, useState } from "react";
import { Field, useFormikContext } from "formik";
import _get from "lodash/get";
import { useDispatch, useSelector } from "react-redux";
import { format } from "date-fns";
import { getFullName } from "utils";
import OnlyOfficeDocumentEditor from "components/lib/Shared/OnlyOfficeDocumentEditor";
import { getUploadChangeDocumentsAsync } from "state/slices/company";
import SpinnerIcon from "components/lib/Shared/Icons/SpinnerIcon";
import { Constants } from "config/constants";
import { getManageCompanyUploadDocuments } from "config/changesDocumentData";
import FileUploadForm from "./FileUploadForm";

const ChangedDocumentsUpdated = ({
  uploadRequestType = "",
  field,
  form,
  disable = false,
  resolvedFields = [],
  documentsFor = "",
  ...props
}) => {
  const { setFieldValue } = useFormikContext();
  const dispatch = useDispatch();
  const { company } = useSelector((state) => state.companyDashboardSlice);
  const { articlesOfAssociation } = company;
  const templateVersions = articlesOfAssociation?.template?.versions ?? [];
  const latestTemplateVersion =
    templateVersions[templateVersions.length - 1]?.summary;
  const currentUser = useSelector((state) => state.userSlice);
  const [documentName, setDocumentName] = useState("");
  const handleSetValue = (e) => {
    const selectedValue = e.target.value;
    setFieldValue(field.name, {
      ...field.value,
      [e.target.name]: selectedValue,
    });
  };
  const getConsentDocument = async () => {
    let payload;
    if (uploadRequestType === "Director Approval") {
      payload = {
        officialType: "authorized person",
        fileType: Constants.Template_FILE_TYPES.BOD_RESOLS_CHANGES,
        typeOfChangeForMaintainCompany: "appointment",
        multipleAppointments: form.values.officials.length > 0 ? true : false,
        officials: form.values.officials,
        boardResolutionArticle: articlesOfAssociation?.template
          ? latestTemplateVersion?.resolutionApprovalSignatories?.for
          : "",
      };
    } else {
      payload = {
        ...form.values,
        appointmentInfo: {
          selectedDesignation: form.values.official.designation,
        },
        appointmentDate: form.values.official.appointmentDate
          ? form.values.official.appointmentDate
          : form.values.identificationDetails.appointmentDate,
        fileType: Constants.Template_FILE_TYPES.CONSENT_TO_ACT,
      };
    }
    const data = await dispatch(
      getUploadChangeDocumentsAsync({
        companyId: company._id,
        data: payload,
      })
    );
    setFieldValue(field.name, {
      ...field.value,
      consentResolutionDocumentName: data.payload.fileName,
    });
    setDocumentName(data.payload.fileName);
  };
  useEffect(() => {
    if (
      field.value.subModeType === "platform-resolution-type" &&
      !field.value.consentResolutionDocumentName
    ) {
      getConsentDocument();
    } else {
      setDocumentName(field.value.consentResolutionDocumentName);
    }
  }, [field.value.subModeType]);
  return (
    <div className="mt-4 flex flex-col">
      {/* tabs are here */}
      <div className="flex flex-col">
        <span>
          Select below whether the change document(s) have been signed or not:
        </span>
        <div className="grid grid-flow-col justify-stretch mt-6">
          <div className="flex items-center">
            <label
              htmlFor="documentsSigned"
              className="flex items-center cursor-pointer"
            >
              <Field
                id="documentsSigned"
                name={"modeType"}
                form={form}
                type={"radio"}
                value={"pre-signed-documents"}
                checked={field.value.modeType === "pre-signed-documents"}
                disabled={disable}
                onBlur={field.onBlur}
                onChange={handleSetValue}
                className={`cursor-pointer form-radio h-4 w-4 border-green-900 border-2 focus:ring-green-50`}
              />
              <span className="ml-2">I have signed documents</span>
            </label>
          </div>
          <div className="flex items-center">
            <label
              htmlFor="documentsNotSigned"
              className="flex items-center cursor-pointer"
            >
              <Field
                id={"documentsNotSigned"}
                name={"modeType"}
                form={form}
                type={"radio"}
                value={"not-signed-documents"}
                checked={field.value.modeType === "not-signed-documents"}
                disabled={disable}
                onBlur={field.onBlur}
                onChange={handleSetValue}
                className={`cursor-pointer form-radio h-4 w-4 border-green-900 border-2 focus:ring-green-50`}
              />
              <span className="ml-2">Not yet signed</span>
            </label>
          </div>
        </div>
      </div>
      <div>
        {field.value.modeType === "pre-signed-documents" && (
          <div className="container bg-white mt-6 px-4 py-4 shadow-sm rounded-md">
            <Field
              name="uploadChangeDocuments.fileUploads"
              component={FileUploadForm}
              documentData={getManageCompanyUploadDocuments("changeDocuments")}
              disabled={disable}
            />
          </div>
        )}
        {field.value.modeType === "not-signed-documents" && (
          <div className="mt-6">
            <div className=" bg-white px-4 py-6 mt-2 mb-4 shadow-sm rounded-md">
              <h3 className="mb-2">
                {
                  (documentsFor = "uploadChangeDocuments"
                    ? "Consent To Act Forms"
                    : "Board Resolutions approving the change(s)")
                }
              </h3>
              <div className="bg-[#EDF0F5]  flex flex-col justify-evenly mb-4 px-4 py-4 shadow-sm rounded-md space-y-3">
                <div className="flex items-center">
                  <label
                    htmlFor="ownResolutionType"
                    className="flex items-center cursor-pointer"
                  >
                    <Field
                      id="ownResolutionType"
                      name="subModeType"
                      type="radio"
                      form={form}
                      value="self-resolution-type"
                      checked={
                        field.value.subModeType === "self-resolution-type"
                      }
                      disabled={disable}
                      onBlur={field.onBlur}
                      onChange={handleSetValue}
                      className={`cursor-pointer form-radio h-4 w-4 border-green-900 border-2 focus:ring-green-50`}
                    />
                    <span className="ml-2">
                      {
                        (documentsFor = "uploadChangeDocuments"
                          ? "Upload your own Consent To Act Form"
                          : "Upload your own Board Resolutions")
                      }
                    </span>
                  </label>
                </div>
                {field.value.subModeType === "self-resolution-type" && (
                  <Field
                    name="uploadChangeDocuments.fileUploads"
                    component={FileUploadForm}
                    documentData={getManageCompanyUploadDocuments(
                      "changeDocuments"
                    )}
                    disabled={false}
                  />
                )}
                <div className="flex items-center">
                  <label
                    htmlFor="platformResolutionType"
                    className="flex items-center cursor-pointer"
                  >
                    <Field
                      id="platformResolutionType"
                      name="subModeType"
                      form={form}
                      type={"radio"}
                      value={"platform-resolution-type"}
                      checked={
                        field.value.subModeType === "platform-resolution-type"
                      }
                      disabled={disable}
                      onBlur={field.onBlur}
                      onChange={handleSetValue}
                      className={`cursor-pointer form-radio h-4 w-4 border-green-900 border-2 focus:ring-green-50`}
                    />
                    <span className="ml-2">
                      {
                        (documentsFor = "uploadChangeDocuments"
                          ? "Adopting our Consent To Act Template"
                          : "Adopting our Board Resolutions Template")
                      }
                    </span>
                  </label>
                </div>
                {field.value.subModeType === "platform-resolution-type" && (
                  <>
                    <div className="px-4 py-4 mt-2 mb-4">
                      {documentName ? (
                        <OnlyOfficeDocumentEditor
                          url={`https://sfl-bucket.s3.us-west-2.amazonaws.com/images/${documentName}`}
                          editorKey={`${currentUser._id}-${company._id}-${documentName}`}
                          userFullName={getFullName(currentUser.names)}
                          userId={currentUser._id}
                          companyId={company._id}
                          documentType={"word"}
                          fileType={"docx"}
                          title={`${format(
                            new Date(),
                            "dd/MM/yyyy"
                          )} - Consent to Act - ${getFullName(
                            currentUser.names
                          )} - (Template 004)`}
                          mode={"edit"}
                          zoom={-2}
                          containerHeight={"600px"}
                          showFullScreenToggle={true}
                          permissions={{ edit: true }}
                        />
                      ) : (
                        <p className="flex justify-center py-4">
                          <SpinnerIcon className="text-gray-500" />
                        </p>
                      )}
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
export default ChangedDocumentsUpdated;
